import { QueryKeys } from '../../../queryDefaults/QueryKeys';
import { useHighFrequencyRefreshQuery } from '../../../queryDefaults/baseQueries/useHighFrequencyRefreshQuery';
import { DrugApi } from '../../../apis/DrugApi/DrugApi.ts';
import { DrugFormulation, IDrugFormulation } from '../Drug.ts';

export function useGetDrugFormulations(id?: string) {
    return useHighFrequencyRefreshQuery({
        queryKey: [QueryKeys.drugFormulation, id],
        queryFn: async () => {
            if (!id) return null;
            const result: IDrugFormulation = await DrugApi.getDrugFormulations(id);
            return new DrugFormulation(result as IDrugFormulation);
        },
        enabled: !!id && Number(id) > 0,
    });
}
